import React from 'react';
import { BookOpen, Share2, Network, Tablet } from 'lucide-react';

const UniqueFeatures = () => {
  return (
    <section className="relative py-24 bg-gradient-to-b from-[#1a1a1a] to-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl sm:text-6xl md:text-7xl font-bold text-white mb-6" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
            UNIQUE
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#D4AF37] to-[#FFD700]">
              PROGRAM FEATURES
            </span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Revolutionary tools designed for real transformation
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Encyclopedia of Shared Humanity */}
          <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0f0f0f] border border-[#D4AF37]/20 rounded-xl p-6 transform hover:scale-105 transition-all duration-300 hover:border-[#D4AF37] group">
            <div className="w-14 h-14 bg-gradient-to-br from-[#D4AF37] to-[#FFD700] rounded-lg flex items-center justify-center mb-4 group-hover:rotate-12 transition-transform duration-300">
              <BookOpen className="w-7 h-7 text-[#0a0a0a]" />
            </div>
            <h3 className="text-xl font-bold text-white mb-3" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
              ENCYCLOPEDIA OF SHARED HUMANITY
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              Access a comprehensive library of stories, wisdom, and lessons from those who've walked this path before you.
            </p>
          </div>

          {/* Social Media Integration */}
          <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0f0f0f] border border-[#D4AF37]/20 rounded-xl p-6 transform hover:scale-105 transition-all duration-300 hover:border-[#D4AF37] group">
            <div className="w-14 h-14 bg-gradient-to-br from-[#D4AF37] to-[#FFD700] rounded-lg flex items-center justify-center mb-4 group-hover:rotate-12 transition-transform duration-300">
              <Share2 className="w-7 h-7 text-[#0a0a0a]" />
            </div>
            <h3 className="text-xl font-bold text-white mb-3" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
              SOCIAL MEDIA PLATFORM
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              Connect, share progress, and build meaningful relationships within a supportive community environment.
            </p>
          </div>

          {/* Professional Networking */}
          <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0f0f0f] border border-[#D4AF37]/20 rounded-xl p-6 transform hover:scale-105 transition-all duration-300 hover:border-[#D4AF37] group">
            <div className="w-14 h-14 bg-gradient-to-br from-[#D4AF37] to-[#FFD700] rounded-lg flex items-center justify-center mb-4 group-hover:rotate-12 transition-transform duration-300">
              <Network className="w-7 h-7 text-[#0a0a0a]" />
            </div>
            <h3 className="text-xl font-bold text-white mb-3" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
              NETWORKING OPPORTUNITIES
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              Build professional connections, find mentors, and access career resources to support your reentry.
            </p>
          </div>

          {/* Tablet Curriculum */}
          <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0f0f0f] border border-[#D4AF37]/20 rounded-xl p-6 transform hover:scale-105 transition-all duration-300 hover:border-[#D4AF37] group">
            <div className="w-14 h-14 bg-gradient-to-br from-[#D4AF37] to-[#FFD700] rounded-lg flex items-center justify-center mb-4 group-hover:rotate-12 transition-transform duration-300">
              <Tablet className="w-7 h-7 text-[#0a0a0a]" />
            </div>
            <h3 className="text-xl font-bold text-white mb-3" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
              TABLET-BASED CURRICULUM
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              Interactive digital workbooks with multimedia content, progress tracking, and instant feedback.
            </p>
          </div>
        </div>

        {/* Additional Features Highlight */}
        <div className="mt-12 bg-gradient-to-r from-[#1a1a1a] via-[#D4AF37]/5 to-[#1a1a1a] border border-[#D4AF37]/30 rounded-2xl p-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold text-[#D4AF37] mb-2" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
                24/7
              </div>
              <p className="text-gray-300">Access to Resources</p>
            </div>
            <div>
              <div className="text-4xl font-bold text-[#D4AF37] mb-2" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
                PEER
              </div>
              <p className="text-gray-300">Support Network</p>
            </div>
            <div>
              <div className="text-4xl font-bold text-[#D4AF37] mb-2" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
                LIFE
              </div>
              <p className="text-gray-300">Changing Tools</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UniqueFeatures;
